import {
  type EventSpotCheckTemplate,
  type SpotCheckTemplate,
  type SpotCheckTemplateCategory,
} from '@solinkcorp/event-standard/lib/src/types';
import classNames from 'classnames';
import useLocale from 'src/hooks/useLocale';
import { useSelector } from 'stores/store';
import { type SpotCheckCategoryKey } from '../SpotCheckTemplatesView';
import styles from './SpotCheckTemplatesSelection.module.sass';

interface SpotCheckTemplatesSelectionProps {
  spotCheckTemplateCategories: Record<string, SpotCheckTemplateCategory> | undefined;
  spotCheckCategoryKeys: SpotCheckCategoryKey[];
  selectedCategoryKey: string | null;
  selectedSpotCheckCategoryKey: SpotCheckCategoryKey | null;
  updateSelectedCategoryKey: (key: string | null) => void;
  updateSelectedSpotCheckCategoryKey: (key: SpotCheckCategoryKey | null) => void;
  templates: SpotCheckTemplate[] | EventSpotCheckTemplate[];
  spotCheckCategoryMap: Record<SpotCheckCategoryKey, { name: string }>;
}

export default function SpotCheckTemplatesSelection(props: SpotCheckTemplatesSelectionProps) {
  const {
    spotCheckTemplateCategories,
    updateSelectedCategoryKey,
    updateSelectedSpotCheckCategoryKey,
    selectedCategoryKey,
    selectedSpotCheckCategoryKey,
    spotCheckCategoryKeys,
    spotCheckCategoryMap,
  } = props;
  const locale = useLocale();
  const language = locale.locale;
  const spotCheckMode = useSelector((state) => state.filter.spotCheckMode);
  const isScheduledSpotCheckMode = spotCheckMode && ['scheduled', 'event'].includes(spotCheckMode);

  return (
    <div className={styles.spotCheckTemplatesSelection}>
      <div className={styles.spotCheckTemplatesSelectionContent}>
        <div>
          <h3>{locale.scheduledAIChat.templates}</h3>
          <ul>
            <li key="all">
              <button
                className={classNames({ [styles.selected]: selectedCategoryKey === 'all' })}
                onClick={() => updateSelectedCategoryKey('all')}
              >
                {locale.general.all}
              </button>
            </li>
            {spotCheckTemplateCategories && (
              <>
                {Object.keys(spotCheckTemplateCategories).map((categoryKey) => (
                  <li key={categoryKey}>
                    <button
                      className={classNames({
                        [styles.selected]: categoryKey === selectedCategoryKey,
                      })}
                      onClick={() => updateSelectedCategoryKey(categoryKey)}
                    >
                      {spotCheckTemplateCategories?.[categoryKey]?.i18n?.[language]?.name}
                    </button>
                  </li>
                ))}
              </>
            )}
          </ul>
        </div>
        {isScheduledSpotCheckMode && (
          <div>
            <h3>{locale.scheduledAIChat.spotChecks}</h3>
            <ul>
              {spotCheckCategoryKeys.map((categoryKey) => (
                <li key={categoryKey}>
                  <button
                    className={classNames({
                      [styles.selected]: categoryKey === selectedSpotCheckCategoryKey,
                    })}
                    onClick={() => updateSelectedSpotCheckCategoryKey(categoryKey)}
                  >
                    {spotCheckCategoryMap[categoryKey].name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
